export default __webpack_public_path__ + "img/event-substitution-out.cfb1f905.svg";